<template>
    <div>
        <span>{{ message }}</span>
    </div>
</template>

<script>
export default {
    name: "VoiceAgentKnowledgeBaseCreated",
    props: {
        activity: {
            type: Object,
            required: true
        }
    },
    computed: {
        message() {
            return this.$t('notification.voiceAgentKnowledgeBaseCreated', {
                actor: this.$_.get(this.activity, 'actorUser.name'),
                knowledgeBaseName: this.$_.get(this.activity, 'payload.knowledgeBaseName')
            });
        }
    }
};
</script>

